export default function Loading() {
    return (
        <div style={{ width: "100%", height: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <img src="/spinner_transparent.gif" alt="Loading" />
        </div>
    );
}